import React from 'react';
import { CalendarIcon, FolderIcon } from 'lucide-react';
export const CTA = () => {
  return <section className="bg-white py-16" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-73">
        <p className="mt-2 text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-74">
          <span className="block" data-id="element-75">
            Ready To Turn Your Copy Into A Conversion Machine?
          </span>
        </p>
        <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-76">
          Stop losing customers to boring copy. Let's create words that work.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4" data-id="element-77">
          <a href="https://calendly.com/mayhave/30min" className="inline-flex items-center justify-center bg-[#16a34a] text-white px-10 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-78">
            <CalendarIcon className="mr-2 h-5 w-5" data-id="element-79" />
            Book Your Strategy Call
          </a>
          <a href="/portfolio" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-full shadow-sm text-green-700 bg-green-100 hover:bg-green-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-80">
            <FolderIcon className="mr-2 h-5 w-5" data-id="element-81" />
            See My Work
          </a>
        </div>
      </div>
    </section>;
};